import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
//import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';

import { getEntities } from './activity-details-price.reducer';

export const ActivityDetailsPrice = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  //const [sortState, setSortState] = useState(overridePaginationStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search));

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );

  const activityDetailsPriceList = useAppSelector(state => state.activityDetailsPrice.entities);
  const loading = useAppSelector(state => state.activityDetailsPrice.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  /*const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };*/

  return (
    <div>
      <h2 id="activity-details-price-heading" data-cy="ActivityDetailsPriceHeading">
        <Translate contentKey="activitiesApp.activityDetailsPrice.home.title">Activity Details Prices</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="activitiesApp.activityDetailsPrice.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/activity-details-price/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="activitiesApp.activityDetailsPrice.home.createLabel">Create new Activity Details Price</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {activityDetailsPriceList && activityDetailsPriceList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="activitiesApp.activityDetailsPrice.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon='sort' />
                </th>
                <th className="hand" onClick={sort('fromPax')}>
                  <Translate contentKey="activitiesApp.activityDetailsPrice.fromPax">From Pax</Translate>{' '}
                  <FontAwesomeIcon icon='sort' />
                </th>
                <th className="hand" onClick={sort('toPax')}>
                  <Translate contentKey="activitiesApp.activityDetailsPrice.toPax">To Pax</Translate>{' '}
                  <FontAwesomeIcon icon='sort' />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="activitiesApp.activityDetailsPrice.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon='sort' />
                </th>
                <th>
                  <Translate contentKey="activitiesApp.activityDetailsPrice.activity">Activity</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {activityDetailsPriceList.map((activityDetailsPrice, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/activity-details-price/${activityDetailsPrice.id}`} color="link" size="sm">
                      {activityDetailsPrice.id}
                    </Button>
                  </td>
                  <td>{activityDetailsPrice.fromPax}</td>
                  <td>{activityDetailsPrice.toPax}</td>
                  <td>{activityDetailsPrice.price}</td>
                  <td>
                    {activityDetailsPrice.activity ? (
                      <Link to={`/activity-details/${activityDetailsPrice.activity.id}`}>{activityDetailsPrice.activity.name}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/activity-details-price/${activityDetailsPrice.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/activity-details-price/${activityDetailsPrice.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/activity-details-price/${activityDetailsPrice.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="activitiesApp.activityDetailsPrice.home.notFound">No Activity Details Prices found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ActivityDetailsPrice;
